import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SocratesLogo } from '@/components/SocratesLogo';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { PageMeta } from '@/components/PageMeta';
import { Loader2 } from 'lucide-react';


export default function Landing() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect logged-in users to dashboard
  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-stone-900 via-stone-800 to-stone-900 flex items-center justify-center">
        <PageMeta path="/" />
        <Loader2 className="w-8 h-8 animate-spin text-stone-400" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-900 via-stone-800 to-stone-900 text-white flex flex-col">
      <PageMeta path="/" />


      {/* Hero */}
      <main className="container mx-auto px-4 flex-1 flex items-center justify-center">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex justify-center mb-8">
            <SocratesLogo size="large" />
          </div>

          <h1 className="text-5xl font-bold font-caveat mb-6
                          md:text-6xl">
            Socrates
          </h1>

          <p className="text-xl text-stone-300 mb-12 leading-relaxed">
            Choose your league. Pick one team each round. Compete all season.
          </p>

          <div className="flex items-center justify-center gap-4">
            <Link to="/login">
              <Button size="lg" className="bg-white text-stone-900 px-8 font-semibold
                                           hover:bg-stone-100">
                Sign In
              </Button>
            </Link>
            <Link to="/register">
              <Button size="lg" variant="ghost" className="border border-white text-white px-8 font-semibold
                                                            hover:bg-white/10 hover:text-white">
                Register
              </Button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="absolute bottom-0 w-full py-6">
        <div className="container mx-auto px-4 text-center text-stone-500 text-sm space-y-2">
          <div className="flex items-center justify-center gap-4">
            <Link to="/about" className="hover:text-stone-300">About</Link>
            <span className="text-stone-700">&middot;</span>
            <Link to="/terms" className="hover:text-stone-300">Terms</Link>
            <span className="text-stone-700">&middot;</span>
            <Link to="/privacy" className="hover:text-stone-300">Privacy</Link>
          </div>
          <p>&copy; {new Date().getFullYear()} Socrates.</p>
        </div>
      </footer>
    </div>
  );
}
